import { render, staticRenderFns } from "./WordEditor.vue?vue&type=template&id=3d72e9af&"
import script from "./WordEditor.vue?vue&type=script&lang=ts&"
export * from "./WordEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports